// TODO update this to import from commmons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import { ShopTaxPoliciesData } from '@reverbdotcom/commons/src/gql/graphql';
import ShopTaxPoliciesInternal from './shop_tax_policies_internal';

interface Props {
  shop: ShopTaxPoliciesData.Fragment;
}

export const ShopTaxPoliciesFragment = gql`
  fragment ShopTaxPoliciesData on Shop {
    _id
    taxPolicies {
      displayLocation
      displayRate
      policyType
    }
  }
`;

export default function ShopTaxPolicies({ shop }: Props) {
  if (!shop) return null;

  return (<ShopTaxPoliciesInternal taxPolicies={shop.taxPolicies} />);
}
